
import TotalPrice from '~/components/profile/shopping-list/TotalPrice.vue'

export default {
  components: {
    TotalPrice,
  },

  props: {
    shoppingList: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      hovered: false,
    }
  },
}
